module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGF02-dfb1e9f59f69c7ada0718a46cadf9580.png";